import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { useBillingContext } from "../BillingContext";
import { BillingDetailsContainer } from "../BillingDetailsContainer";
import { AddonRow } from "./AddonRow";
import { useManageAddonModal } from "./ManageAddonsModal";

const localeRoot = "settings.billing.manage_billing.addons";

export const Addons = () => {
  const { currentPlan, refetchCurrentPlan } = useBillingContext();
  const addonsDetails = currentPlan?.addons_details;
  const manageAddonsModal = useManageAddonModal();

  const openManageAddonsModal = () => {
    void manageAddonsModal.show({
      refetchCurrentPlan: () => {
        refetchCurrentPlan();
      },
    });
  };

  return (
    <BillingDetailsContainer>
      <div className="flex flex-col gap-y-5">
        <div className="flex items-center justify-between">
          <Typography.LabelLg weight="semibold">
            {t(`${localeRoot}.title`)}
          </Typography.LabelLg>
          <Button variant="secondary" onClick={openManageAddonsModal}>
            {t(`${localeRoot}.manage`)}
          </Button>
        </div>

        <div className="flex flex-col gap-y-2">
          {addonsDetails?.items?.map(item => (
            <AddonRow key={item.id} item={item} />
          ))}
        </div>
      </div>
    </BillingDetailsContainer>
  );
};
